<template>
    <actions-menu v-model:dialogEdit="editRequestDialog" :ShowDialogConsult="true" :ShowDialogDelete="false"
        :ShowDialogEdit="!isEditMode && IsClient()" 
        dialogConsult="DeliveryClientOrdersDetails" :Id="Id" :dialogConsultUrl="idOrder" />

    <v-dialog v-model="editRequestDialog" v-if="editRequestDialog">
        <v-card elevation="0" width="700px" class="py-2 px-4" style="border-radius: 12px">
            <v-card-title class="justify-content-center mb-2">
                <span class="title">
                    {{ $t("ProductType.Add") }}
                </span>
            </v-card-title>

            <div class="row justify-content-start mb-2">
                <div class="col">
                    <v-card-title class="text-left">
                        {{ $t("ProductType.Name") }}
                        <span class="red">*</span>
                    </v-card-title>
                    <v-text-field :value="ProductTypeName" id="Title" name="Title" maxlength="30" hide-details
                        :readonly="!isEditMode" :class="!isEditMode ? 'readonly-field' : ''" persistent-placeholder
                        :placeholder="$t('placeholder.enter', { itm: $t('ProductType.PlaceHolderTags.Name'), })"
                        variant="outlined" class="rounded-xl"></v-text-field>
                </div>
            </div>

            <div class="row justify-content-start mb-2">
                <div class="col">
                    <v-card-title class="text-left">
                        {{ $t("Delivery.companyName") }}
                        <span class="red">*</span>
                    </v-card-title>
                    <v-autocomplete id="Company" name="companyName" variant="outlined" v-model="companyId"
                        persistent-placeholder
                        :placeholder="$t('placeholder.select', { itm: $t('Delivery.companyName'), })" :items="Companies"
                        item-title="companyName" item-value="id" hide-details :readonly="isEditMode"
                        :class="isEditMode ? 'readonly-field' : ''">
                        <template v-slot:item="{ props, item }">
                            <v-list-item v-bind="props" variant="text">
                                {{ item.companyName }}
                            </v-list-item>
                        </template>
                    </v-autocomplete>
                    <span v-if="msg.companyName" class="warningHint" id="WarningMsgReference">
                        {{ msg.companyName }}
                    </span>
                </div>
            </div>

            <div class="row justify-content-start mb-2">
                <div class="col">
                    <v-card-title class="text-left">
                        {{ $t("PickupPoint.PickupPoint") }}
                    </v-card-title>
                    <v-autocomplete id="PickupPoint" name="PickupPoint" variant="outlined"
                        v-model="IdPickupPointLocation" persistent-placeholder
                        :placeholder="$t('placeholder.select', { itm: $t('PickupPoint.PickupPoint'), })"
                        :items="PickupPointLocation" item-title="locationName" item-value="idPickupPointLocation"
                        hide-details :readonly="isEditMode" :class="isEditMode ? 'readonly-field' : ''">
                        <template v-slot:item="{ props, item }">
                            <v-list-item v-bind="props" variant="text">
                                {{ item.LocationName }}
                            </v-list-item>
                        </template>
                    </v-autocomplete>
                </div>
            </div>

            <card-actions :yes="AssignToCompany" v-model:no="editRequestDialog" :loader="loader" :yesDisable="loader"
                width="300px" :yesTitle="$t('actions.save')" />
        </v-card>
    </v-dialog>
</template>

<script>
import actionsMenu from "@/genericComponent/actionsMenu.vue";
import cardActions from "@/genericComponent/cardActions.vue";
import {
    setDeliveryOrderForCompany,
    isDelivery,
    DeliveryAcceptance,
    isClient,
} from "@/api/index";
export default {
    components: { actionsMenu, cardActions },
    props: [
        "idOrder",
        "Id",
        "ProductTypeName",
        "ProductTypeId",
        "deliveryCompanyId",
        "deliveryCompanyName",
        "getDeliveryOrders",
        "IsAccepted",
        "PickupPointLocation"
    ],
    mounted() {

    },
    data() {
        return {
            editRequestDialog: false,
            isEditMode: this.IsAccepted,
            item: null,
            dialog: false,
            Title: null,
            msg: [],
            dialogValidation: false,
            loader: false,
            dialogRefuse: false,
            companyId: this.deliveryCompanyId,
            buttonLoader: false,
            Companies: [],
            IdPickupPointLocation: null,
        };
    },
    methods: {
        isDelivery() {
            return isDelivery();
        },
        IsClient() {
            return isClient();
        },
        deliveryOrderAcceptance(status) {
            DeliveryAcceptance(this.idOrder, status)
                .then(() => {
                    this.getDeliveryOrders();
                })
                .catch((error) => {
                    console.error(error);
                });
        },
        ActiveWarningSnackBar() {
            this.getParent("MainLayout").ActiveWarningSnackBar();
        },
        ActiveSavedSnackBar() {
            this.getParent("MainLayout").ActiveSavedSnackBar();
        },
        ActiveDeletedSnackBar() {
            this.getParent("MainLayout").ActiveDeletedSnackBar();
        },
        getParent(name) {
            let p = this.$parent;
            while (typeof p !== "undefined") {
                if (p.$options.name == name) {
                    return p;
                } else {
                    p = p.$parent;
                }
            }
            return false;
        },
        AssignToCompany() {
            this.loader = true;
            if (this.companyId == null) {
                this.msg["companyName"] = this.$t("warningInput.isrequired", {
                    itm: this.$t("Brands.Name"),
                });
            } else {
                this.msg["companyName"] = "";
                setDeliveryOrderForCompany(this.companyId, this.idOrder, this.IdPickupPointLocation)
                    .then(() => {
                        this.ActiveSavedSnackBar();
                        this.editRequestDialog = false;
                        this.getDeliveryOrders();
                    })
                    .catch((error) => {
                        this.ActiveWarningSnackBar();
                        console.error(error);
                    });
            }
            this.loader = false;
        },
    },
};
</script>
<style scoped>
.v-card-title {
    font-family: inter;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    color: #5b6d8e;
}
</style>
